export interface PatentLegalStatusApi {
    /**
     * 获取专利法律状态
     */
    getPatentLegalStatus(): Promise<any>;
}

export const PatentLegalStatusApi = Symbol.for('PatentLegalStatusApi');
